@if (error()) {
  <div class="animate-top-slide rounded-xl rounded-tl-none bg-negative-5 p-3 text-negative-150 xs:p-5">
    <div class="flex items-center gap-2 font-heading text-base font-medium">
      <span class="flex h-10 w-10 items-center justify-center">
        <svg
          focusable="false"
          preserveAspectRatio="xMidYMid meet"
          fill="currentColor"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2,16H2A14,14,0,1,0,16,2,14,14,0,0,0,2,16Zm23.15,7.75L8.25,6.85a12,12,0,0,1,16.9,16.9ZM8.24,25.16A12,12,0,0,1,6.84,8.27L23.73,25.16a12,12,0,0,1-15.49,0Z"></path>
        </svg>
      </span>
      <span class="leading-5">{{ 'common.error-badge.title' | translate }}</span>
    </div>
    @for (violation of _error()?.violations; track violation) {
      <div class="grid-auto-rows grid gap-2 py-2 text-sm text-neutral-100 xs:text-base sm:text-base">
        <div class="grid grid-cols-[128px_1fr] items-center">
          <div class="h-fit max-w-fit items-center justify-center gap-4 rounded-md bg-negative-25 px-4 py-2 text-center font-semibold text-negative-150">
            {{ violation.code }}
          </div>
          <div class="p-2">{{ violation.message }}</div>
        </div>
      </div>
    }
  </div>
}
